import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import type { Filter } from '@/entities/station';
import sortStations from '../lib/sortStations';
import type { StationWithSaving } from './stationWithSaving.schema';

type NaverMapStore = {
	currentZoomLevel: number;
	minZoomLevel: number;
	filter: Filter;
	selectedStationId: string | null;
	stationsWithSavings: StationWithSaving[];
	sortedStations: StationWithSaving[];
	setCurrentZoomLevel: (currentZoomLevel: number) => void;
	setMinZoomLevel: (minZoomLevel: number) => void;
	setSelectedStationId: (stationId: string | null) => void;
	setStationsWithSavings: (stationsWithSavings: StationWithSaving[]) => void;
	sortStations: (filter: Filter) => void;
};

const useNaverMapStore = create<NaverMapStore>()(
	persist(
		immer((set) => ({
			currentZoomLevel: 0,
			minZoomLevel: 0,
			filter: 'savings' as Filter,
			selectedStationId: null,
			stationsWithSavings: [],
			sortedStations: [],
			setCurrentZoomLevel: (currentZoomLevel) => set({ currentZoomLevel }),
			setMinZoomLevel: (minZoomLevel) => set({ minZoomLevel }),
			setSelectedStationId: (selectedStationId) => set({ selectedStationId }),
			setStationsWithSavings: (stationsWithSavings) =>
				set((state) => ({
					stationsWithSavings,
					sortedStations: sortStations(stationsWithSavings, state.filter),
				})),
			sortStations: (filter) =>
				set((state) => ({
					filter,
					sortedStations: sortStations([...state.sortedStations], filter),
				})),
		})),
		{
			name: 'mantang-naver-map-storage',
			version: 1,
			migrate: (persistedState) => {
				if (!persistedState || typeof persistedState !== 'object') {
					return persistedState;
				}

				return {
					...persistedState,
					filter: 'savings' as Filter,
				};
			},
		},
	),
);

export default useNaverMapStore;
